import { execute } from '@/api/execute'
import { GET, POST, PUT, DELETE } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'manager/mixers'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  litelist (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/list/`, params))
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  },

  deleteById (id) {
    return execute(DELETE, `${ENDPOINT}/${id}/`)
  },

  updateCalibration (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/calibration/`, payload)
  }
}
